import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import cloneDeep from 'lodash/cloneDeep'
import _ from 'lodash'

const descriptionEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_description_views
    ? entities.project_description_views
    : {}
)

const projectDescriptionRawSelector = createSelector(
    descriptionEntitySelector,
  (entity) => {
    if(Object.values(entity)[0]){
      return cloneDeep(Object.values(entity)[0])
    } else {
      return {}
    }
  }
)

const projectDescriptionSourceSelector = createSelector(
  projectDescriptionRawSelector,
    (descriptionObj) => {
        if (_.isEmpty(descriptionObj)) return null
        const { description, risk } = descriptionObj
        return { ...descriptionObj, description: description == null ? '' : description, risk: risk === true}
    }
)

const projectDescriptionCollapseSelector = state => state.project.description.collapse
const projectDescriptionEditSelector = state => state.project.description.edit
const projectDescriptionTextSelector = state => state.project.description.description
const projectDescriptionRiskSelector = state => state.project.description.risk

export {
    projectDescriptionCollapseSelector,
    projectDescriptionEditSelector,
    projectDescriptionSourceSelector,
    projectDescriptionRiskSelector,
    projectDescriptionTextSelector,
}

